<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tony qualified in Law and practiced as a solicitor in his country of birth, South Africa before emigrating to Israel in 1961. Since then, after a stint on a kibbutz, he lectured at the Tel Aviv University and opened a chain of fast food restaurants and established a travel company specializing in incentive travel. The company won several international awards. For the last 34 years, as a highly respected trainer, he has conducted seminars in personal development and self-awareness in Israel, Turkey, the United Kingdom and around the world with his wife, Orit Josefi Wiseman in their company, Outlook. He has also been a coach and mentor, often dealing with issues pertaining to intimate relationships, which formed the basis of the book, Relationships I.Q., written together with Orit and published by Austin Macauley.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b0aa161c